//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import httpApi from "../../api/cashier";
import { Toast } from "mint-ui";
import wx from "weixin-js-sdk";
export default {
    name: "merchantTransfer",
    data() {
        return {
            bannerArr: [],
            goodsDetail: {},
            isloading: false,
            isDisabled: false,
            transferMsg: ''
        };
    },
    created() {
        this.reload();
        this.getquery();
    },
    filters: {
        hiddenName(name) {
            if (!name) return '';
            const len = name.length;
            if (len === 1) return name;
            return '*'.repeat(len - 1) + name[len - 1];
        },
    },
    methods: {
        getquery() {
            let query = JSON.parse(sessionStorage.getItem("data"));
            this.goodsDetail = {
                ...query
            }
            this.queryTransferOrderStatus(query.myapp_id, query.out_trade_no)
        },
        queryTransferOrderStatus(myapp_id, out_trade_no) {
            httpApi.queryTransferOrderStatus({
                out_trade_no,
                myapp_id
            }).then((res) => {
                if (res.status == 200) {
                    this.isDisabled = res.data.transfer_status == 0 ? false : true;
                    if (res.data.transfer_status != 0) this.transferMsg = res.data.transfer_msg || '';
                }
            });
        },
        reload() {
            let query = JSON.parse(sessionStorage.getItem("data"));
            let { myapp_id, total_amount, acctype, auth_code } = query;
            let config = {
                myapp_id,
                total_amount,
                acctype,
                auth_code,
            };
            let _this = this;
            httpApi.cashierMsg(config).then((res) => {
                if (res.status == 200) {
                    if (res.data.ad) {
                        _this.bannerArr = [
                            {
                                imgUrl:
                                    res.data.ad.request_url ||
                                    require("../../assets/img/banner.png"),
                                expand: "1",
                                url: res.data.ad.url || "",
                            },
                        ];
                        _this.desc = res.data.ad.desc;
                    } else {
                        _this.bannerArr = [{
                            imgUrl: require("../../assets/img/banner.png"),
                            expand: "1",
                            url: "",
                        },
                        ];
                    }
                } else {
                    Toast({
                        message: res.msg || "操作异常，请刷新重试",
                        duration: 2000,
                    });
                }
                this.isloading = false;
            }).catch((err) => {
                Toast({
                    message: err.msg || "该场景暂无可用的支付渠道",
                    duration: 2000,
                });
                this.isloading = false;
            });
        },
        submit() {
            if (this.isDisabled && this.transferMsg) return Toast({
                message: this.transferMsg,
                duration: 2000,
            });
            let _this = this
            this.isloading = true;
            let params = {
                ...JSON.parse(sessionStorage.getItem("data"))
            }
            httpApi.merchantTransfer(params).then((res) => {
                this.isloading = false;
                if (res.status == 200) {
                    let query = res.data;
                    wx.config({
                        debug: false,
                        appId: query.appid,
                        timestamp: query.time_stamp,
                        nonceStr: query.nonce_str,
                        signature: query.sign
                    });
                    wx.error(function (err) {
                        console.log("错误原因", err);
                    });
                    wx.ready(function () {
                        wx.checkJsApi({
                            jsApiList: ['requestMerchantTransfer'],
                            success: function (res) {
                                if (res.checkResult['requestMerchantTransfer']) {
                                    WeixinJSBridge.invoke('requestMerchantTransfer', {
                                        mchId: query.mch_id,
                                        appId: query.appid,
                                        package: query.package_info,
                                    }, function (res) {
                                        if (res.err_msg === 'requestMerchantTransfer:ok') {
                                            _this.$router.push({ path: '/withdrawalResult' });
                                        }
                                    }
                                    );
                                } else {
                                    alert('你的微信版本过低，请更新至最新版本。');
                                }
                            }
                        });
                    });

                } else {
                    Toast({
                        message: res.msg || "操作异常，请刷新重试",
                        duration: 2000,
                    });
                }

            }).catch((err) => {
                Toast({
                    message: err.msg || "提现失败，请联系管理员",
                    duration: 2000,
                });
                this.isloading = false;
            });
        },
        //跳转
        link(url) {
            if (!url) return false;
            // 校验网址
            let reg =
                /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
            let regIp =
                /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)((2[0-4][0-9])|(25[0-5])|(1[0-9]{0,2})|([1-9][0-9])|([1-9]))\.(((2[0-4][0-9])|(25[0-5])|(1[0-9]{0,2})|([1-9][0-9])|([0-9]))\.){2}((2[0-4][0-9])|(25[0-5])|(1[0-9]{0,2})|([1-9][0-9])|([1-9]))$/;

            if (regIp.test(url) || reg.test(url)) {
                location.href = url;
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/merchantTransfer/index.vue